// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b3d82a94","453":"d138d655","732":"725d7423"}[chunkId] + ".chunk.js";
};